// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"909":"06a570f0","998":"a8648ac7"}[chunkId] + ".chunk.js";
};